import {
    type CabinClassRequest,
    type UserLevelRange,
} from '@clients/FlightApi';

type Service = {
    id: number;
    title: string;
    price: number;
    description: string;
    unitTitle?: string;
    needDescription?: boolean;
    image?: string;
    discount: number;
    levelRange?: UserLevelRange;
    flightClass?: CabinClassRequest;
};
export default class SuggestionService {
    id: number;
    title: string;
    price: number;
    discount: number;
    description: string;
    unitTitle: string;
    needDescription?: boolean;
    image: string;
    levelRange?: UserLevelRange;
    flightClass?: CabinClassRequest;
    constructor({
        id,
        title,
        price,
        description,
        unitTitle,
        needDescription,
        image,
        discount,
        levelRange,
        flightClass,
    }: Service) {
        this.id = id;
        this.title = title;
        this.price = price;
        this.description = description;
        this.unitTitle = unitTitle || 'تعداد';
        this.needDescription = needDescription;
        this.image = image || '/img/suggested-service/fallback.png';
        this.discount = discount;
        this.levelRange = levelRange;
        this.flightClass = flightClass;
    }
}

export interface SelectedSuggestionServices {
    service: SuggestionService;
    count: number;
    description?: string;
}
